import { defaultOptions } from 'primevue/config';

/**
 * Locale PrimeVue (es-CL): textos de componentes, calendario, tablas y filtros en español de Chile.
 * Parte de `defaultOptions.locale` para conservar claves que el merge superficial no rellena.
 */
export function buildPrimeVueLocaleEsCL() {
  return {
    ...defaultOptions.locale,
    startsWith: 'Empieza con',
    contains: 'Contiene',
    notContains: 'No contiene',
    endsWith: 'Termina en',
    equals: 'Es igual a',
    notEquals: 'Distinto de',
    noFilter: 'Sin filtro',
    lt: 'Menor que',
    lte: 'Menor o igual que',
    gt: 'Mayor que',
    gte: 'Mayor o igual que',
    dateIs: 'La fecha es',
    dateIsNot: 'La fecha no es',
    dateBefore: 'Fecha anterior a',
    dateAfter: 'Fecha posterior a',
    clear: 'Limpiar',
    apply: 'Aplicar',
    matchAll: 'Cumplir todas',
    matchAny: 'Cumplir cualquiera',
    addRule: 'Agregar regla',
    removeRule: 'Quitar regla',
    accept: 'Aceptar',
    reject: 'Rechazar',
    choose: 'Elegir',
    upload: 'Subir',
    cancel: 'Cancelar',
    completed: 'Completado',
    pending: 'Pendiente',
    weak: 'Débil',
    medium: 'Medio',
    strong: 'Fuerte',
    passwordPrompt: 'Ingresá una contraseña',
    emptyFilterMessage: 'Sin resultados',
    searchMessage: 'Hay {0} resultados',
    selectionMessage: '{0} elementos seleccionados',
    emptySelectionMessage: 'Nada seleccionado',
    emptySearchMessage: 'Sin resultados',
    emptyMessage: 'Sin opciones disponibles',
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    firstDayOfWeek: 1,
    showMonthAfterYear: false,
    dateFormat: 'dd/mm/yy',
    today: 'Hoy',
    weekHeader: 'Sem',
    chooseDate: 'Elegir fecha',
    chooseMonth: 'Elegir mes',
    chooseYear: 'Elegir año',
    prevMonth: 'Mes anterior',
    nextMonth: 'Mes siguiente',
    prevYear: 'Año anterior',
    nextYear: 'Año siguiente',
    prevDecade: 'Década anterior',
    nextDecade: 'Década siguiente',
    prevHour: 'Hora anterior',
    nextHour: 'Hora siguiente',
    prevMinute: 'Minuto anterior',
    nextMinute: 'Minuto siguiente',
    prevSecond: 'Segundo anterior',
    nextSecond: 'Segundo siguiente',
    am: 'a. m.',
    pm: 'p. m.',
    aria: {
      ...defaultOptions.locale.aria,
      trueLabel: 'Verdadero',
      falseLabel: 'Falso',
      nullLabel: 'Sin selección',
      star: '1 estrella',
      stars: '{star} estrellas',
      selectAll: 'Todo seleccionado',
      unselectAll: 'Nada seleccionado',
      close: 'Cerrar',
      previous: 'Anterior',
      next: 'Siguiente',
      navigation: 'Navegación',
      scrollTop: 'Ir arriba',
      moveTop: 'Mover al inicio',
      moveUp: 'Subir',
      moveDown: 'Bajar',
      moveBottom: 'Mover al final',
      moveToTarget: 'Mover al destino',
      moveToSource: 'Mover al origen',
      moveAllToTarget: 'Mover todo al destino',
      moveAllToSource: 'Mover todo al origen',
      pageLabel: 'Página {page}',
      firstPageLabel: 'Primera página',
      lastPageLabel: 'Última página',
      nextPageLabel: 'Página siguiente',
      prevPageLabel: 'Página anterior',
      rowsPerPageLabel: 'Filas por página',
      jumpToPageDropdownLabel: 'Ir a página (lista)',
      jumpToPageInputLabel: 'Ir a página (número)',
      selectRow: 'Fila seleccionada',
      unselectRow: 'Fila sin seleccionar',
      expandRow: 'Fila expandida',
      collapseRow: 'Fila contraída',
      showFilterMenu: 'Mostrar menú de filtros',
      hideFilterMenu: 'Ocultar menú de filtros',
      filterOperator: 'Operador de filtro',
      filterConstraint: 'Condición de filtro',
      editRow: 'Editar fila',
      saveEdit: 'Guardar cambios',
      cancelEdit: 'Cancelar edición',
      listView: 'Vista de lista',
      gridView: 'Vista de grilla',
      slide: 'Diapositiva',
      slideNumber: '{slideNumber}',
      zoomImage: 'Ampliar imagen',
      zoomIn: 'Acercar',
      zoomOut: 'Alejar',
      rotateRight: 'Girar a la derecha',
      rotateLeft: 'Girar a la izquierda',
      listLabel: 'Lista de opciones',
    },
  };
}
